/*
  ───────────────────────────────────────────────────────────────────────────
  REGIS · MÉTODO — animaciones de entrada (scroll reveal)
  - Un ÚNICO IntersectionObserver compartido por toda la página "Método Regis".
  - Observa los elementos [data-reveal] y les añade .is-visible una sola vez.
  - El estado inicial oculto vive en el CSS de cada sección, protegido por
    @media (prefers-reduced-motion: no-preference); aquí solo se revela.
  - prefers-reduced-motion: reduce  → se revela todo al instante, sin observar.
  - Sin IntersectionObserver (navegador antiguo) → se revela todo al instante.
  - Se re-inicializa en shopify:section:load para no romperse en el editor.
  - Vanilla, sin dependencias, cargado con defer desde cada sección que lo usa.
  ───────────────────────────────────────────────────────────────────────────
*/
(function () {
  // El script se incluye desde varias secciones: ejecutar la lógica una sola vez.
  if (window.__regisMetodoReveal) return;
  window.__regisMetodoReveal = true;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(el) {
    el.classList.add('is-visible');
  }

  function revealAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-reveal]').forEach(reveal);
  }

  // Sin animación (preferencia del usuario o navegador sin soporte): todo visible.
  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealAll(document);
    document.addEventListener('shopify:section:load', function (event) {
      revealAll(event.target);
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );

  function observe(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-reveal]:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observe(document);
    });
  } else {
    observe(document);
  }

  // Editor de temas: al recargar o añadir una sección, observar sus nuevos nodos.
  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });
})();
